module.exports = __webpack_public_path__ + "static/media/cecily_brown.bf6302f5.jpg";